import type { AasApiAdapter, CheckProviderKeyInput, UpsertProviderInput } from "../adapter";
import { requestJson } from "../http";
import type { KeyCheckResult, ProvidersResponse } from "../types";

export const providersApi: AasApiAdapter["providers"] = {
	async list() {
		return requestJson<ProvidersResponse>("/api/providers");
	},
	async upsert(input: UpsertProviderInput) {
		await requestJson("/api/providers", { method: "POST", body: input });
	},
	async delete(name: string) {
		await requestJson<void>(`/api/providers/${encodeURIComponent(name)}`, {
			method: "DELETE",
		});
	},
	async check(input: CheckProviderKeyInput) {
		return requestJson<KeyCheckResult>("/api/providers/check", { method: "POST", body: input });
	},
};
